export const INVISIBLE_SEPARATOR = '⁣';
